<template>
  <additional-service-card :id="id"/>
</template>

<script>
import AdditionalServiceCard from "@/components/app/additional-services/AdditionalServiceCard.vue";

export default {
  name: "Additional Service",
  components: {
    AdditionalServiceCard
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    isCreating() {
      return this.id === 'create'
    },
    isShowing() {
      return !this.isCreating
    }
  },
}
</script>

<style scoped>

</style>
